import axios from '../axios.jsx';
import { useEffect, useState } from "react";
import EvaluacionRiesgo from './EvaluacionRiesgo.jsx';
import Swal from 'sweetalert2';
import { Modal, Button } from 'react-bootstrap';
import Select from 'react-select/creatable';
import { useParams, useNavigate, useLocation } from 'react-router-dom';


const URI = 'sat/';
const URI2 = 'fuente/';
const URI_CITERI = 'activarEri/';
const URI3 = 'sendmailSAT/'
const URI4 = 'sendmailSAR/'
const URI_AGE = 'agenda/';

const CompCreateBlog = () => {
  const [fechaIngreso, setFechaIngreso] = useState('');
  const [semanaepi, setsemanaepi] = useState('');
  const [municipio, setmunicipio] = useState(null);
  const [fuentes, setfuentes2] = useState('');
  const [codigoSat, setCodigoSat] = useState('');
  const [eventos, seteventos] = useState('');
  const [eventos2, seteventos2] = useState([]);
  const [titulo, settitulo] = useState('');
  const [resumen, setresumen] = useState('');
  const [fuente, setfuente] = useState([]);
  const [gestor, setgestor] = useState('');
  const [mostrarEvaluacion, setMostrarEvaluacion] = useState(false);
  const [evaluacion, setEvaluacion] = useState('');
  const [nivel, setNivel] = useState('');
  const [respuesta, setRespuesta] = useState('');
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const tipo = params.get('tipo');
  const [Activa_SAR, setActivaSAR] = useState("");  // o "NO" por defecto
  const [Activa_ERI, setActivaERI] = useState("");

    const [showModalCita, setShowModalCita] = useState(false);
     const [showModalenviomasivo, setshowModalenviomasivo] = useState(false);
    const [showModalCitaERI, setShowModalCitaERI] = useState(false);
    const [fechaCitaERI, setFechaCitaERI] = useState('');
  const [horaCitaERI, setHoraCitaERI] = useState('');
  const [temaERI, setTemaERI] = useState('');
    const [fechaCita, setFechaCita] = useState('');
  const [horaCita, setHoraCita] = useState('');
  const [horaCitafin, setHoraCitafin] = useState('');
  const [tema, setTema] = useState('');
  const [correoConsecutivo, setCorreoConsecutivo] = useState('');
  const [correos, setCorreos] = useState([]);
  const [participantesCita, setParticipantesCita] = useState([]);
  const [lugar, setlugar] = useState(null);
  const [enviomasivos, setenviomasivos] = useState([]);
  const URI_CIT = 'citar_sar/';
  const URI_ETIQUETAS = 'etiquetacorreo/';

  // ── Etiquetas de correo — grupos guardados que llenan de un solo clic
  // todos los correos de ese grupo en "Integrantes". Ahora viven en la
  // base de datos (tabla etiquetas_correo), compartidas entre todos los
  // usuarios del sistema — no solo en este navegador.
  const [etiquetasCorreo, setEtiquetasCorreo] = useState([]);
  const [etiquetaSeleccionada, setEtiquetaSeleccionada] = useState(null);
  const [mostrarCrearEtiqueta, setMostrarCrearEtiqueta] = useState(false);
  const [nombreNuevaEtiqueta, setNombreNuevaEtiqueta] = useState('');

  // Blindaje: si por algún motivo el backend devuelve "correos" como un
  // string en vez de arreglo ya parseado (pasa si la columna quedó como
  // TEXT en vez de JSON, o si Sequelize no lo deserializó), esto evita
  // que se reparta letra por letra al hacer spread — se intenta parsear
  // como JSON, y si falla, se descarta esa etiqueta en vez de romper todo.
  const aArrayCorreos = (valor) => {
    if (Array.isArray(valor)) return valor
    if (typeof valor === "string") {
      try { const parsed = JSON.parse(valor); return Array.isArray(parsed) ? parsed : [] }
      catch { return [] }
    }
    return []
  }

  const cargarEtiquetasCorreo = () => {
    axios.get(URI_ETIQUETAS)
      .then(res => setEtiquetasCorreo(res.data.map(e => ({ ...e, correos: aArrayCorreos(e.correos) }))))
      .catch(() => {});
  };

  const { codigo } = useParams();


    const resetCitaFields = () => {
    setFechaCita('');
    setHoraCita('');
    setHoraCitafin('');
    setCorreoConsecutivo('');
    setParticipantesCita([]);
    setTema('');
  };

  const esEmailValido = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validarAntesGuardar = () => {
  if (enviomasivos.length === 0) {
    alert("Selecciona al menos un correo");
    return false;
  }

  const invalidos = enviomasivos.filter(e => !esEmailValido(e));

  if (invalidos.length > 0) {
    alert("Tienes correos inválidos: \n" + invalidos.join(", "));
    return false;
  }

  return true;
};


  const resetCitaERIFields = () => {
    setFechaCitaERI('');
    setHoraCitaERI('');
    setTemaERI('');
  };

  const resetcorreo = () => {
    setenviomasivos([]);
  };

  // Aplica una etiqueta: agrega sus correos a los ya seleccionados (sin
  // duplicar), en vez de reemplazarlos — así se pueden combinar varias
  // etiquetas o sumar correos sueltos.
  const aplicarEtiquetaCorreo = (nombreEtiqueta) => {
    const etiqueta = etiquetasCorreo.find(e => e.nombre === nombreEtiqueta);
    if (!etiqueta) return;
    setenviomasivos(prev => [...new Set([...prev, ...etiqueta.correos])]);
    setEtiquetaSeleccionada(nombreEtiqueta);
  };

  const crearEtiquetaCorreo = async (nombre, correosParaGuardar) => {
    const nombreLimpio = nombre.trim();
    if (!nombreLimpio) {
      Swal.fire({ icon: 'warning', title: 'Ponle un nombre a la etiqueta', timer: 1800, showConfirmButton: false });
      return false;
    }
    if (!correosParaGuardar.length) {
      Swal.fire({ icon: 'warning', title: 'No hay correos para guardar en la etiqueta', timer: 1800, showConfirmButton: false });
      return false;
    }
    const yaExiste = etiquetasCorreo.some(e => e.nombre.toLowerCase() === nombreLimpio.toLowerCase());
    if (yaExiste) {
      Swal.fire({ icon: 'warning', title: `Ya existe una etiqueta llamada "${nombreLimpio}"`, timer: 2000, showConfirmButton: false });
      return false;
    }
    try {
      const res = await axios.post(URI_ETIQUETAS, { nombre: nombreLimpio, correos: correosParaGuardar });
      if (res.data?.etiqueta) {
        cargarEtiquetasCorreo();
        return true;
      }
      // El backend devuelve {message: "..."} tanto en éxito sin "etiqueta"
      // como en error — si no vino la etiqueta creada, algo falló.
      Swal.fire({ icon: 'error', title: res.data?.message || 'No se pudo crear la etiqueta', timer: 2200, showConfirmButton: false });
      return false;
    } catch {
      Swal.fire({ icon: 'error', title: 'No se pudo crear la etiqueta — revisa tu conexión', timer: 2200, showConfirmButton: false });
      return false;
    }
  };

  // Para no preguntar de más: si los correos que se están por enviar ya
  // coinciden exactamente con una etiqueta guardada, no tiene sentido
  // ofrecer crear una nueva.
  const correosYaCoincidenConEtiqueta = () => {
    const actual = new Set(enviomasivos);
    return etiquetasCorreo.some(et => {
      const deEtiqueta = new Set(et.correos);
      return deEtiqueta.size === actual.size && [...deEtiqueta].every(c => actual.has(c));
    });
  };



  const navigate = useNavigate();

 const store = async () => {


  if (!respuesta && tipo == "SAT") {
    Swal.fire({
      icon: 'warning',
      title: 'Acción no permitida',
      text: 'Debe evaluar el riesgo antes de guardar.',
    });
    return;
  }






  Swal.fire({
    title: 'Guardando información...',
    text: 'Por favor espera un momento',
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });

  try {
    console.log("🟦 Enviando solicitud principal a:", URI);
    const satRes = await axios.post(URI, {
      createAt: fechaIngreso,
      Fecha_identificacion: fechaIngreso,
      Codigo: codigoSat,
      Titulo: titulo,
      Semana_epi: semanaepi,
      Gestor: gestor,
      Fuente: fuentes,
      Departamento: 'Amazonas',
      Municipio: municipio?.value || "",
      Resumen: resumen,
      Evento: eventos,
      Respuesta: respuesta,
      Puntaje: evaluacion,
      Nivel_Riesgo: nivel,
      Activa_SAR: Activa_SAR,
      Masivos: enviomasivos.join(', '),
      Activa_ERI: Activa_ERI,
      Cierra_SAT: "NO",
      
    });
    console.log("✅ Respuesta guardado SAT:", satRes.data);

    console.log("🟦 Enviando cápsula:", URI3);
    
    const capsulaRes = await axios.get(URI3, {
      params: { codigo: codigoSat, tipo: "CAPSULA", gestor: gestor, correos: enviomasivos },
   });
    console.log("✅ Respuesta cápsula:", capsulaRes.data);

    if (Activa_ERI === "SI") {
      console.log("🟨 Enviando cita ERI:", URI_CITERI);
      const eriRes = await axios.post(URI_CITERI, {
        Codigo: codigoSat,
        Fecha: fechaCitaERI,
        Hora: horaCitaERI,
        Accion: temaERI,
        Gestor: gestor,
      });
      console.log("✅ Respuesta cita ERI:", eriRes.data);
    }



    if (Activa_SAR === "SI") {
      console.log("🟨 Enviando cita SAR:", URI_CIT);
      const sarRes = await axios.post(URI_CIT, {
        Tipo_Sala: 'SARS',
        Codigo_SAT: codigoSat,
        Fecha: fechaCita,
        Hora_inicio: horaCita,
        Hora_fin: horaCitafin,
        Consecutivo: correoConsecutivo,
        Citados: participantesCita.join(', '),
        Tema: tema,
        Lugar: lugar?.value || "",
        Gestor: gestor,
      });
      console.log("✅ Respuesta cita SAR:", sarRes.data);

      console.log("🟨 Registrando agenda:", URI_AGE);
      const agendaRes = await axios.post(URI_AGE, {
        Codigo: codigoSat,
        Fecha: fechaCita,
        Hora_inicio: horaCita,
        Hora_fin: horaCitafin,
        Titulo: `SALA DE ANÁLISIS DE RIESGO EN SALUD (SARS) ${codigoSat}`,
        Responsable: gestor,
        Id_Cita: sarRes.data?.id,
      });
      console.log("✅ Agenda registrada:", agendaRes.data);

      console.log("🟨 Enviando correo SAR:", URI4);
     const correoRes = await axios.get(URI4, {
      params: { codigo: codigoSat, id: sarRes.data?.id, emails: participantesCita.join(', ') },
      });
      console.log("✅ Resultado envío correo SAT:", correoRes.data);
    }

    Swal.fire({
      icon: 'success',
      title: 'Guardado exitoso',
      text: 'La información se ha guardado correctamente.',
      timer: 2000,
      showConfirmButton: false,
    });

    navigate('/app');
  } catch (error) {
    console.error("❌ Error en alguna solicitud:", error.response?.data || error.message);
    Swal.fire({
      icon: 'error',
      title: 'Error al guardar',
      text: 'Ocurrió un problema al guardar la información.',
    });
  }
};


  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    setFechaIngreso(formattedDate);

    const username = sessionStorage.getItem('username');
    if (username) setgestor(username);

    axios.get('directorio/').then(res => {
    const opciones = res.data.map(c => ({ value: c.Correo, label: c.Correo }));
    setCorreos(opciones);
        });

    cargarEtiquetasCorreo();


    getBlogById();
    geteventoById();
    if (tipo) {
      obtenerCodigo();
    }
  }, [tipo]);

  const evaluarRiesgo = () => {
    setMostrarEvaluacion(true);
  };

  const onResultadosListos = ({ evaluacion, nivel, respuesta }) => {
    setEvaluacion(evaluacion);
    setNivel(nivel);
    setRespuesta(respuesta);
    setMostrarEvaluacion(false);
  };


  const getBlogById = async () => {
    try {
      const res = await axios.get(URI2);
      setfuente(res.data);
    } catch (error) {
      console.error('Error al obtener fuentes:', error);
    }
  };

  const geteventoById = async () => {
    try {
      const res = await axios.get('/eventos')
      seteventos2(res.data);
    } catch (error) {
      console.error('Error al obtener eventos:', error);
    }
  };

  const obtenerCodigo = async () => {
    try {
      const res = await axios.get(`/codigosat?tipo=${tipo}`);
      setCodigoSat(res.data.codigo);
    } catch (error) {
      console.error('Error al obtener el código:', error);
    }
  };

  return (
    <div className="container">
      <h2 className="text-center mb-5 mt-3">FORMULARIO SISTEMA DE ALERTA TEMPRANA</h2>
      <form onSubmit={(e) => {
        e.preventDefault();
        setshowModalenviomasivo(true);}
      }>
        <div className="row">
          <div className="col-md-6">
            {/* Campos lado izquierdo */}
            {/* ...[campos existentes]... */}
            <label className="mb-1">{tipo === 'SEN' ? 'Código SEÑAL' : 'Código SAT'}</label>
            <input type="text" className="form-control mb-2" value={codigoSat} readOnly />
            <label className="mb-1">Fecha de ingreso</label>
            <input type="date" className="form-control mb-2" value={fechaIngreso} readOnly />
            <label className="mb-1">Semana epidemiologica</label>
            <input type="text" className="form-control mb-2" value={semanaepi} onChange={(e) => setsemanaepi(e.target.value)} required />
            <label className="mb-1">Gestor SAT</label>
            <input type="text" className="form-control mb-2" value={gestor} readOnly />
            <label className="mb-1">Municipio</label>

<Select
  options={[
    { value: "LETICIA", label: "LETICIA" },
    { value: "PUERTO NARIÑO", label: "PUERTO NARIÑO" },
    { value: "ENCANTO", label: "ENCANTO" },
    { value: "CHORRERA", label: "CHORRERA" },
    { value: "PEDRERA", label: "PEDRERA" },
    { value: "LA VICTORIA", label: "LA VICTORIA" },
    { value: "MIRITI-PARANA", label: "MIRITI-PARANA" },
    { value: "PUERTO ALEGRIA", label: "PUERTO ALEGRIA" },
    { value: "PUERTO ARICA", label: "PUERTO ARICA" },
    { value: "PUERTO SANTANDER", label: "PUERTO SANTANDER" },
    { value: "TARAPACA", label: "TARAPACA" }
  ]}
  value={municipio}
  onChange={(selected) => setmunicipio(selected)}
  placeholder="Seleccione o escriba un municipio"
  formatCreateLabel={(input) => `Agregar "${input}"`}
  isClearable
  menuPortalTarget={document.body}
  styles={{
    menuPortal: base => ({ ...base, zIndex: 9999 }),

    control: base => ({
      ...base,
      textAlign: "left"
    }),

    placeholder: base => ({
      ...base,
      textAlign: "left",
      justifyContent: "flex-start",
      width: "100%"
    }),

    singleValue: base => ({
      ...base,
      textAlign: "left",
      justifyContent: "flex-start",
      width: "100%"
    }),

    input: base => ({
      ...base,
      textAlign: "left"
    })
  }}
/>

            <label className="mb-1">Fuente</label>
            <select className="form-control mb-2" value={fuentes} onChange={(e) => setfuentes2(e.target.value)} required>
              <option value="">Selecciona una opción</option>
              {fuente.map(option => <option key={option.id} value={option.nombre}>{option.nombre}</option>)}
            </select>
            <label className="mb-1">Evento</label>
            <select className="form-control mb-2" value={eventos} onChange={(e) => seteventos(e.target.value)} required>
              <option value="">Selecciona una opción</option>
              {eventos2.map(option => <option key={option.id} value={option.nombre}>{option.nombre}</option>)}
            </select>
          </div>

          <div className="col-md-6">
            {/* Campos lado derecho */}
            <label>Título</label>
            <textarea className="form-control mb-2" value={titulo} onChange={(e) => settitulo(e.target.value.toUpperCase())} required />
            <label>Resumen</label> 
            <textarea
            className="form-control mb-2"
            style={{ height: '200px', resize: 'vertical' }}
            value={resumen}
           onChange={(e) => setresumen(e.target.value)}
           required
            />

            <div className="row g-3">
              <div className="col-md-6">
                <label>Evaluación del riesgo</label>
                <input className="form-control" value={evaluacion} readOnly
          required />
              </div>
              <div className="col-md-6">
                <label>Nivel del riesgo</label>
                <input type="text" className="form-control" value={nivel} readOnly />
              </div>
            </div>
            <label className="mt-2">Respuesta</label>
            <input type="text" className="form-control mb-3" value={respuesta} readOnly />

            <div className="text-center">
  <button
    type="button"
    className="btn btn-primary"
    onClick={evaluarRiesgo}
    disabled={tipo === 'SEN'}
  >
    Evaluar Riesgo
  </button>
  
  
</div>
<div className="row g-3">
              <div className="col-md-6">
                <label>Activa SARS</label>
                <select
                className="form-control mb-2"
                value={Activa_SAR}
                onChange={(e) => {
          const val = e.target.value;
          setActivaSAR(val);
          if (val === "SI") {
            setShowModalCita(true);
          }
        }}
        
                required
              >
                <option value="">Selecciona una opcion</option>
                <option value="SI">SI</option>
                <option value="NO">NO</option>
              </select> </div>
              <div className="col-md-6">
                <label>Despliegue ERI</label>
                <select
                className="form-control mb-2"
                value={Activa_ERI}
                onChange={(e) => {
                const valERI = e.target.value;
                setActivaERI(valERI);
                if (valERI === "SI") {
               setShowModalCitaERI(true);
                 }
                }}
                required
              >
                <option value="">Selecciona una opcion</option>
                <option value="SI">SI</option>
                <option value="NO">NO</option>
              </select>


              </div></div>



          </div>
        </div>

        <div className="form-group text-center mt-4">
  <button
    type="button"
    className="btn btn-outline-danger me-2"
    onClick={() => {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Perderás los datos no guardados.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, volver',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
      }).then((result) => {
        if (result.isConfirmed) {


          navigate('/app');
        }
      });
    }}
  >
    <i className="fas fa-arrow-left"></i> Volver
  </button>

  <button type="submit" className="btn btn-success">
    <i className="fas fa-paper-plane"></i> Enviar
  </button>
      </div>

      


        {/* Envio masivo de correos */}
       <Modal show={showModalenviomasivo}
        onHide={() => {
        setshowModalenviomasivo(false);
      }}  
      backdrop="static"
      keyboard={false}
      size='lg'
      dialogClassName="modal-envio"
  >
        <Modal.Header><Modal.Title>ENVIO MASIVO DE CAPSULA INFORMATIVA</Modal.Title></Modal.Header>
        <Modal.Body>
          <div className="form-group">

            <label>Etiqueta de correos:</label>
            <div className="d-flex gap-2 align-items-center mb-2" style={{ flexWrap: 'wrap' }}>
              <select
                className="form-control"
                style={{ maxWidth: 260 }}
                value={etiquetaSeleccionada || ''}
                onChange={(e) => { if (e.target.value) aplicarEtiquetaCorreo(e.target.value); }}
              >
                <option value="">Selecciona una etiqueta...</option>
                {etiquetasCorreo.map(et => (
                  <option key={et.nombre} value={et.nombre}>{et.nombre} ({et.correos.length})</option>
                ))}
              </select>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => setMostrarCrearEtiqueta(p => !p)}
              >
                {mostrarCrearEtiqueta ? 'Cancelar' : '+ Crear etiqueta'}
              </Button>
            </div>

            {mostrarCrearEtiqueta && (
              <div className="d-flex gap-2 align-items-center mb-3" style={{ flexWrap: 'wrap' }}>
                <input
                  type="text"
                  className="form-control"
                  style={{ maxWidth: 260 }}
                  placeholder="Nombre de la etiqueta"
                  value={nombreNuevaEtiqueta}
                  onChange={(e) => setNombreNuevaEtiqueta(e.target.value)}
                />
                <Button
                  variant="success"
                  size="sm"
                  onClick={async () => {
                    const ok = await crearEtiquetaCorreo(nombreNuevaEtiqueta, enviomasivos);
                    if (ok) {
                      setNombreNuevaEtiqueta('');
                      setMostrarCrearEtiqueta(false);
                      Swal.fire({ icon: 'success', title: 'Etiqueta creada', timer: 1500, showConfirmButton: false });
                    }
                  }}
                >
                  Guardar etiqueta con los correos actuales
                </Button>
              </div>
            )}

            <label>Integrantes:</label>
            <Select
             isMulti
            options={correos}
            value={enviomasivos.map(e => ({
            value: e,
            label: e
            }))}

  placeholder="Selecciona o escribe correos..."

  formatCreateLabel={(input) => `Agregar "${input}"`}

  onChange={(selected) => {
    if (!selected) {
      setenviomasivos([]);
      return;
    }

    // Extraer valores
    let lista = selected.map(s => s.value.trim());

    // Quitar duplicados
    lista = [...new Set(lista)];

    setenviomasivos(lista);
  }}

  menuPortalTarget={document.body}

  styles={{
    menuPortal: base => ({ ...base, zIndex: 9999 }),

    option: (base, state) => ({
      ...base,
      color: esEmailValido(state.data.value) ? "black" : "red"
    }),

    multiValueLabel: (base, state) => ({
      ...base,
      color: esEmailValido(state.data.value) ? "black" : "red"
    })
  }}
            />
            
            <p className="mt-2">
  Correos seleccionados: <b>{enviomasivos.length}</b>
</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            resetcorreo();
            setshowModalenviomasivo(false);
          }}>Cancelar</Button>
          <Button variant="success" onClick={async () => {
            if (!validarAntesGuardar()) return;

    if (!correosYaCoincidenConEtiqueta()) {
      const { isConfirmed: quiereCrear } = await Swal.fire({
        icon: 'question',
        title: '¿Guardar estos correos como una etiqueta nueva?',
        text: 'Así la próxima vez los seleccionas todos de un clic.',
        showCancelButton: true,
        confirmButtonText: 'Sí, crear etiqueta',
        cancelButtonText: 'No, gracias',
        confirmButtonColor: '#198754',
      });
      if (quiereCrear) {
        const { value: nombreEtiqueta } = await Swal.fire({
          title: 'Nombre de la etiqueta',
          input: 'text',
          inputPlaceholder: 'Ej: sarampion',
          showCancelButton: true,
          confirmButtonText: 'Crear',
        });
        if (nombreEtiqueta) await crearEtiquetaCorreo(nombreEtiqueta, enviomasivos);
      }
    }

    // Si pasa todas las validaciones:
    setshowModalenviomasivo(false);
    store();
    // llamar tu función para guardar o continuar
     
                    
          }}>Guardar</Button>
        </Modal.Footer>
      </Modal>

      
       {/* Modal Activar Cita */}
       <Modal show={showModalCita}
        onHide={() => {
        setShowModalCita(false);
        resetCitaFields();
      }}  
      backdrop="static"
      keyboard={false}
  >
        <Modal.Header><Modal.Title>Activar Sala de Análisis</Modal.Title></Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>Fecha:</label>
            <input type="date" className="form-control" value={fechaCita} onChange={e => setFechaCita(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Hora Inicio:</label>
            <input type="time" className="form-control"  value={horaCita} onChange={e => setHoraCita(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Hora Fin:</label>
            <input type="time" className="form-control" value={horaCitafin} onChange={e => setHoraCitafin(e.target.value)} />
          </div>
          <div className="form-group">
  <label>Lugar:</label>

  <Select
    options={[
      {
        value: "OFICINA VIGILANCIA EN SALUD PUBLICA",
        label: "OFICINA VIGILANCIA EN SALUD PUBLICA"
      },
      {
        value: "MALOKA - SECRETARIA DE SALUD DEPARTAMENTAL",
        label: "MALOKA - SECRETARIA DE SALUD DEPARTAMENTAL"
      },
      {
        value: "OFICINA PAI DEPARTAMENTAL",
        label: "OFICINA PAI DEPARTAMENTAL"
      },
    ]}
    value={lugar}
    onChange={(selected) => setlugar(selected)}
    placeholder="Seleccione o escriba un lugar"
    isClearable
    menuPortalTarget={document.body}
    styles={{
      menuPortal: base => ({ ...base, zIndex: 9999 })
    }}
  />
</div>


        
          <div className="form-group">
            <label>Consecutivo de Correo:</label>
            <input type="text" className="form-control" value={correoConsecutivo} onChange={e => setCorreoConsecutivo(e.target.value)} />
          </div>
          <div className="form-group">
            
            <label>Participantes:</label>
            <Select
             isMulti
  options={correos}
  value={participantesCita.map(e => ({
    value: e,
    label: e
  }))}

  placeholder="Selecciona o escribe correos..."

  formatCreateLabel={(input) => `Agregar "${input}"`}

  onChange={(selected) => {
    if (!selected) {
      setParticipantesCita([]);
      return;
    }

    // Extraer valores
    let lista = selected.map(s => s.value.trim());

    // Quitar duplicados
    lista = [...new Set(lista)];

    setParticipantesCita(lista);
  }}

  menuPortalTarget={document.body}

  styles={{
    menuPortal: base => ({ ...base, zIndex: 9999 }),

    option: (base, state) => ({
      ...base,
      color: esEmailValido(state.data.value) ? "black" : "red"
    }),

    multiValueLabel: (base, state) => ({
      ...base,
      color: esEmailValido(state.data.value) ? "black" : "red"
    })
  }}
            />
            
            <p className="mt-2">
  Correos seleccionados: <b>{participantesCita.length}</b>
</p>
          </div>
          <div className="form-group">
            <label>Tema a tratar:</label>
            <textarea className="form-control" value={tema} onChange={e => setTema(e.target.value)}required></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowModalCita(false);
            resetCitaFields();
            setActivaSAR("NO");
          }}>Cancelar</Button>
          <Button variant="success" onClick={async () => {
             if (participantesCita.length === 0) {
      // podrías mostrar una alerta, un mensaje de error, etc.
      alert("Por favor selecciona al menos un participante");
      return;
    }
    // Aquí puedes agregar otras validaciones si lo deseas:
    if (!fechaCita || !horaCita || !horaCitafin || !correoConsecutivo || !tema) {
      alert("Todos los campos son requeridos");
      return;
    }

    // Si pasa todas las validaciones:
    setShowModalCita(false);
    // llamar tu función para guardar o continuar
     
                    
          }}>Guardar</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Activar Cita ERI*/}
             <Modal show={showModalCitaERI} onHide={() => {
              setShowModalCita(false);
              resetCitaFields();
            }}backdrop="static"
              keyboard={false}>
              <Modal.Header><Modal.Title>Activar Equipo de Respuesta Inmediata</Modal.Title></Modal.Header>
              <Modal.Body>
                <div className="form-group">
                  <label>Fecha:</label>
                  <input type="date" className="form-control" value={fechaCitaERI} onChange={e => setFechaCitaERI(e.target.value)} />
                </div>
                <div className="form-group">
                  <label>Hora:</label>
                  <input type="time" className="form-control" value={horaCitaERI} onChange={e => setHoraCitaERI(e.target.value)} />
                </div>
                 <div className="form-group">
                  <label>Tema a tratar:</label>
                  <textarea className="form-control" value={temaERI} onChange={e => setTemaERI(e.target.value)}></textarea>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                  setShowModalCitaERI(false);
                  resetCitaERIFields();
                  setActivaERI("NO");

                }}>Cancelar</Button>
                <Button variant="success" onClick={async () => {
                
              // Aquí puedes agregar otras validaciones si lo deseas:
                if (!fechaCitaERI || !horaCitaERI || !temaERI) {
                alert("Todos los campos son requeridos");
                return;
                }

                 setShowModalCitaERI(false);
                }}>Guardar</Button>
              </Modal.Footer>
            </Modal>

      </form>

      {mostrarEvaluacion && (
        <EvaluacionRiesgo onClose={() => setMostrarEvaluacion(false)} onResultadosListos={onResultadosListos} />
      )}
    </div>
  );
};

export default CompCreateBlog;